import { Fragment } from 'react';

import { IdentifierGrid, IdentifierValue } from './styles.js';

const deviceIdentifiers = [
  { label: 'SONDA SaMD', value: '08720892364722' },
  { label: 'SONDA Hub', value: '08720892364715' },
];

const DeviceIdentifiers = () => (
  <IdentifierGrid>
    {deviceIdentifiers.map((device) => (
      <Fragment key={device.label}>
        <span>{device.label}</span>
        <span aria-hidden="true">–</span>
        <IdentifierValue>UDI-DI {device.value}</IdentifierValue>
      </Fragment>
    ))}
  </IdentifierGrid>
);

export default DeviceIdentifiers;
